export const businessWinterBreakMessage = (
  <p>
    Thank you for a wonderful season!
    <br />
    We at Alnarp&apos;s Farm are currently enjoying our well-deserved winter
    break. We would love to continue our collaboration with you next season and
    we&apos;ll reach out to you as soon as we are ready to begin the planning
    process.
    <br />
    Growing together @ Alnarps Agroecology Farm.
  </p>
);
export const ClientWinterBreakMessage = (
  <p>
    Thank you for this wonderful season!
    <br />
    We at Alnarp&apos;s Farm are currently enjoying our well-deserved winter
    break. We would love to continue our collaboration and will reach out to you
    shortly about continuing your subscription for the next season. Growing
    together @ Alnarps Agroecology Farm.
  </p>
);

export const ClientCommingSoonMessage = (
  <p>
    We are so happy to have you with us!
    <br />
    Your subscription has not started yet. You will receive an email the week it
    starts. (Don&apos;t forget to check your spam folder.) Once your
    subscription is active, you&apos;ll be able to change pickup location and
    day here. You can also tell us if a friend is picking up your delivery for
    you. <br />
    We are looking forward to seeing you soon!
    <br />
    Growing together @ Alnarps Agroecology Farm.
  </p>
);
